import { useEffect, useRef, useState } from "react";

/**
 * Intersection Observer hook that triggers once and stays true.
 * Unlike framer-motion's whileInView, this won't re-trigger on re-renders.
 */
export function useInViewOnce(options?: IntersectionObserverInit) {
  const ref = useRef<HTMLDivElement>(null);
  const [hasBeenInView, setHasBeenInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || hasBeenInView) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasBeenInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1, ...options }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasBeenInView, options]);

  return { ref, isInView: hasBeenInView };
}
